import React from 'react';

import { Box } from '@rbilabs/universal-components';
import { UpsellSection } from 'features/cart/components/cart-content/upsell-section';

import { Upsell } from 'pages/cart/upsell';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

const UpsellCarouselWrapper = Box.withConfig({
  marginX: '$4',
});

export const ProductUpsell: React.FC = () => {
  const enableMinimalCartUi = useFlag(LaunchDarklyFlag.ENABLE_MINIMAL_CART_UI);
  if (enableMinimalCartUi) {
    return (
      <UpsellCarouselWrapper>
        <UpsellSection />
      </UpsellCarouselWrapper>
    );
  }
  return (
    <UpsellCarouselWrapper>
      <Upsell />
    </UpsellCarouselWrapper>
  );
};
